import api from './axios';

export const withdrawalAPI = {
  // POST /api/withdrawal/request
  requestWithdrawal: (data) => api.post('/withdrawal/request', data),

  // GET /api/withdrawal/history
  getHistory: (params) => api.get('/withdrawal/history', { params }),

  // GET /api/withdrawal/transfers — approved withdrawals with transfer tracking
  getTransfers: (params) => api.get('/withdrawal/transfers', { params }),
};
